import { suggestCompanyProfileCommand } from '@savgroup-front-common/core/api/Seller/suggestCompanyProfileCommand';

import { getAuthorizedSellersQuery } from './getAuthorizedSellersQuery';
import getSellerAcceptedLanguages from './getSellerAcceptedLanguages';
import { getSellerByIdQuery } from './getSellerByIdQuery';
import { getSellerConfigurationQuery } from './getSellerConfigurationQuery';
import { getVatRateBySellerIdQuery } from './getVatRateBySellerIdQuery';
import { setSellerConfigurationAcceptedLanguagesCommand } from './setSellerConfigurationAcceptedLanguagesCommand';
import { setSellerConfigurationAccountManagerCommand } from './setSellerConfigurationAccountManagerCommand';
import { setSellerConfigurationOtherCommand } from './setSellerConfigurationOtherCommand';
import { setSellerConfigurationTransportCommand } from './setSellerConfigurationTransportCommand';

export const CommonSellerService = {
  getSellerConfigurationQuery,
  getSellerAcceptedLanguages,
  getVatRateBySellerIdQuery,
  getAuthorizedSellersQuery,
  getSellerByIdQuery,
  setSellerConfigurationOtherCommand,
  setSellerConfigurationTransportCommand,
  setSellerConfigurationAccountManagerCommand,
  setSellerConfigurationAcceptedLanguagesCommand,
  suggestCompanyProfileCommand,
};
